var COS = require('./src/cos');
module.exports = COS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cos-js-sdk-v5/index.js
// module id = 204
// module chunks = 1